import { render, staticRenderFns } from "./advDetail.vue?vue&type=template&id=52b64c88&scoped=true"
import script from "./advDetail.vue?vue&type=script&lang=js"
export * from "./advDetail.vue?vue&type=script&lang=js"
import style0 from "./advDetail.vue?vue&type=style&index=0&id=52b64c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b64c88",
  null
  
)

export default component.exports